import ControlButtonGroup from '../components/ControlButtonGroup/ControlButtonGroup';
import ControlButtonGroupRight from '../components/ControlButtonGroup/ControlButtonGroupRight';
import ControlButtonGroupLeft from '../components/ControlButtonGroup/ControlButtonGroupLeft';
import ControlPanel from '../components/ControlPanel/ControlPanel';
import ZoomControl from '../components/ZoomControl/ZoomControl';
import SidePanel from '../components/SidePanel/SidePanel';
import Modal from '../components/Modal/Modal';
import ModalContentManager from './ModalContentManager';
import Map from '../components/Map/Map';
import MapManager from './MapManager';

import * as eventNames from '../customEventStrings';
import * as ids from '../layerIdStrings';

class AppManager {
	constructor() {
		this.appContainer = document.getElementById('appContainer');

		this.components = {
			controlButtonGroupRight: new ControlButtonGroup({
				render: new ControlButtonGroupRight(),
			}),
			controlButtonGroupLeft: new ControlButtonGroup({
				render: new ControlButtonGroupLeft(),
			}),
			controlPanel: new ControlPanel(),
			zoomControl: new ZoomControl(),
			sidePanel: new SidePanel(),
			modal: new Modal(),
			map: new Map(),
		};

		this.modalContentManager = new ModalContentManager(this.components['modal']);
		this.mapManager = new MapManager(this.components['map']);
	}

	mountComponents() {
		this.components['zoomControl'].mount(this.appContainer);
		this.components['controlButtonGroupRight'].mount(this.appContainer);
		this.components['controlButtonGroupLeft'].mount(this.appContainer);
		this.components['controlPanel'].mount(this.appContainer);
		this.components['sidePanel'].mount(this.appContainer);
		this.modalContentManager.mountComponent(this.appContainer);
		this.mapManager.mountComponent(this.appContainer);
	}

	init() {
		this.setComponentControlEventListeners();
		this.mountComponents();
	}

	// listen to global control events among components
	setComponentControlEventListeners() {
		const TOGGLE_BTN_GROUP_BREAKPOINT = 970;

		document.addEventListener(eventNames.OPEN_LAYER_CONTROL, () => {
			this.components['controlPanel'].open();
			this.components['controlButtonGroupRight'].hide();
			if (document.documentElement.clientWidth <= TOGGLE_BTN_GROUP_BREAKPOINT) {
				this.components['controlButtonGroupLeft'].hide();
				this.components['zoomControl'].hide();
			}
		});
		document.addEventListener(eventNames.CLOSE_LAYER_CONTROL, () => {
			this.components['controlButtonGroupRight'].show();
			if (document.documentElement.clientWidth <= TOGGLE_BTN_GROUP_BREAKPOINT) {
				this.components['controlButtonGroupLeft'].show();
				this.components['zoomControl'].show();
			}
		});
		document.addEventListener(eventNames.ZOOM_IN, () => {
			this.mapManager.zoomIn();
		});
		document.addEventListener(eventNames.ZOOM_OUT, () => {
			this.mapManager.zoomOut();
		});
		document.addEventListener(eventNames.OPEN_SIDE_PANEL, () => {
			this.components['sidePanel'].open();
			this.components['zoomControl'].hide();
			this.components['controlButtonGroupLeft'].hide();
			if (document.documentElement.clientWidth <= TOGGLE_BTN_GROUP_BREAKPOINT) {
				this.components['controlButtonGroupRight'].hide();
			}
		});
		document.addEventListener(eventNames.CLOSE_SIDE_PANEL, () => {
			this.components['zoomControl'].show();
			this.components['controlButtonGroupLeft'].show();
			if (document.documentElement.clientWidth <= TOGGLE_BTN_GROUP_BREAKPOINT) {
				this.components['controlButtonGroupRight'].show();
			}
		});
		document.addEventListener(eventNames.OPEN_MODAL, async (e) => {
			if (e.detail.contentType == 'sidepanel' && e.detail.contentKey == 'dialectPanel') {
				document.querySelector(".js-dialect-panel").classList.add("active");
				return;
			}

			// open modal according to id
			// set content
			await this.modalContentManager.setModalContent(e.detail.contentType, e.detail.contentKey, e.detail.extra);
			// open modal
			this.components['modal'].open();
		});
		document.addEventListener(eventNames.CLOSE_MODAL, () => {
			this.mapManager.closePopup();
			// close (and save) content
			this.modalContentManager.removeModalContent();
			this.components['modal'].close();
		});
		document.addEventListener(eventNames.LAYER_ADDED, (e) => {
			this.mapManager.addLayer(e.detail.props);
		});
		document.addEventListener(eventNames.LAYER_REMOVED, (e) => {
			this.mapManager.removeLayer(e.detail.props);
		});
		document.addEventListener(eventNames.RASTER_ADDED, (e) => {
			this.mapManager.addRastrLayer(e.detail.id);
		});
		document.addEventListener(eventNames.RASTER_REMOVED, (e) => {
			this.mapManager.removeRastrLayer(e.detail.id);
		});
		document.addEventListener(eventNames.FILTER_ADDED, (e) => {
			if (e.detail.id == ids.DIALECTS_FINE) {
				this.mapManager.addDialects(e.detail);
			} else {
				this.mapManager.removeMarkers(e.detail.id);
				this.mapManager.addMarkers({id: e.detail.id});
			}
		});
		document.addEventListener(eventNames.MARKER_CLICKED, (e) => {
			this.mapManager.openPopupOnMarkerClick(
				e.detail.marker,
				e.detail.properties
			);
		});
		document.addEventListener(eventNames.PRINT_MAP, () => {
			this.mapManager.printMap();
		});
		document.addEventListener(eventNames.SEARCH_REMOVED, (e) => {
			this.mapManager.onSearchRemoved(e.detail.id, e.detail.data);
		});
		document.addEventListener(eventNames.SEARCH_SELECTED, (e) => {
			this.mapManager.onSearchSelected(e.detail.id, e.detail.data, e.detail.flyTo);
		});
		document.addEventListener(eventNames.SEARCH_WITH_BOUNDS_CHANGE, (e) => {
			this.mapManager.onSearchWithBoundsChange(e.detail.checked);
		});
		document.addEventListener(eventNames.CHANGE_CUSTOM_MARKER_COLOR, (e) => {
			this.mapManager.redrawMarkers();
		});
		document.addEventListener("save-file-click", () => {
			this.mapManager.saveFile();
		});
		document.addEventListener("load-file-click", (e) => {
			this.mapManager.loadFile(e.target.files[0]);
		});
		document.addEventListener("export-file-click", (e) => {
			this.mapManager.exportFile();
		});
	}
}

export default new AppManager();
